// extracted by mini-css-extract-plugin
export default {"pill":"YWQLx8od","pill_disabled":"HsLARxfK","pillDisabled":"HsLARxfK","pillAvatar":"_xwpFbHD","pillCaret":"M9ND3444"};